import React, { Component } from 'react';
import {inject, observer} from 'mobx-react';
import Form, {getInitialChecklistForm,
    getInitialDropwdownForm,
    getInitialTextForm
} from './components/Form';
import {DropDown, InputField} from '../InputForms'
import {TextButton, TextButtonTypes} from '../Buttons';
import DialogModal from '../DialogModal';
import styles from './style.css';
import sortBy from 'lodash/sortBy';
import {getFilesFromDropEvent, readFileAsText} from '../../utils'


class AddTaskModal extends Component {
    render() {
        return <EditTaskModal {...this.props}/>
    }
}

@inject('store', 'notificationsStore', 'localizationStore')
@observer
export class EditTaskModal extends Component {
    constructor(props) {
        super(props)
        this.downloadLinkRef = React.createRef()
        this.state = {
            id: '',
            description: '',
            interval: 0,
            inputTitle: '',
            inputElements: [],
            dragging: false
        }
    }

    static getStateFromAgentTask(agentTask, includeId=true) {
        const {defaultPeriodicalUpdatesEnabled, defaultPeriodicalUpdatesInterval, defaultPeriodicalUpdatesIntervalCount} = agentTask
        return {
            id: includeId ? agentTask.id : undefined,
            description: agentTask.description,
            interval: intervalSwitch(defaultPeriodicalUpdatesEnabled, defaultPeriodicalUpdatesInterval, defaultPeriodicalUpdatesIntervalCount),
            inputId: agentTask.input.id,
            inputTitle: agentTask.input.title,
            inputElements: sortBy(agentTask.input.indexedInputFields, 'index')
        }
    }

    static buildAgentTaskFromState(state, includeId=true) {
        const intervalData = getIntervalData(state.interval)
        return {
            id: includeId ? state.id : undefined,
            description: state.description,
            ...intervalData,
            input: {
                id: state.inputId || undefined,
                title: state.inputTitle,
                indexedInputFields: state.inputElements
            }
        }
    }

    onModalInputChange = (event) => {
        let state = this.state
        state[event.target.name] = event.target.value
        this.setState(state)
    }

    onIntervalChange = (event) => {
        const {locale} = this.props.localizationStore
        this.setState({
            interval: Math.max(0, locale.task_interval_options.findIndex(_ =>  _ === event.target.value))
        })
    }

    onDragOver = (event) => {
        event.preventDefault()
    }
    onDrop = async (event) => {
        event.preventDefault()

        const fileGenerator = getFilesFromDropEvent(event)
        const file = fileGenerator.next().value
        fileGenerator.return()
        if (file) {
            try {
                const text = await readFileAsText(file)
                this.parseFileData(text)
            } catch (e) {
                console.log(e)
            }
        } else {
            let data = event.dataTransfer.getData('text')
            let index = this.draggableElements.findIndex(e => e.inputType+e.questionType === data)
            if(index > -1) {
                let element = this.draggableElements[index]
                const newInputElement = element.model
                const inputElements = this.state.inputElements.slice()
                if (inputElements.length > 0) {
                    newInputElement.index = inputElements[inputElements.length - 1].index + 1
                } else {
                    newInputElement.index = 1
                }
                inputElements.push(newInputElement)
                this.setState({inputElements});
            }
        }
    }
    handleProvideJsonFile = (e) => {
        e.preventDefault()
        const json = JSON.stringify({agentTask: EditTaskModal.buildAgentTaskFromState(this.state, false)}, null, 2)
        const blob = new File([new Blob([json], {type: 'text/plain'})], 'agent-configuration.json')
        const objectURL = URL.createObjectURL(blob)
        this.setState({downloadLink: objectURL}, () => {this.downloadLinkRef.current.click()})
    }
    onDragStart = (event) => {
        event.dataTransfer.dropEffect = 'copy'
        event.dataTransfer.effectAllowed = 'copy'
        event.dataTransfer.setData('text', event.target.id)
        this.setState({dragging: true})
    }
    onDragEnd = (event) => {
        this.setState({dragging: false})
    }
    draggableElements = [
        {
            inputType: 'TEXTBOX',
            name: this.props.localizationStore.locale.textForm,
            get model() { return getInitialTextForm()}
        },
        {
            inputType: 'QUESTION',
            questionType: 'DROPDOWN',
            name: this.props.localizationStore.locale.dropdownForm,
            get model() { return getInitialDropwdownForm()}
        },
        {
            inputType: 'QUESTION',
            questionType: 'SINGLE_CHOICE',
            name: this.props.localizationStore.locale.checklistForm,
            get model() { return getInitialChecklistForm()}
        }
    ]
    onDeleteForm = (index) => {
        this.setState({inputElements: this.state.inputElements.filter((e, i) => i !== index)})
    }

    onFormInputChange = (index, state, newIndex) => {
        const inputElements = this.state.inputElements.slice()
        const inputElement = inputElements[index].inputElement
        if (inputElement.question) {
            inputElement.question = state
        }
        if (inputElement.textbox) {
            inputElement.textbox = state
        }
        if (newIndex) {
            inputElements[index].index = newIndex
            inputElements.sort((a, b) => a.index - b.index)
        }
        this.setState({inputElements})
    }

    onAddTask = () => {
        this.props.agent.createTaskRequest(EditTaskModal.buildAgentTaskFromState(this.state))
            .then(this.props.onSuccess)
    }

    onEditTask = () => {
        const agentTask = EditTaskModal.buildAgentTaskFromState(this.state)
        this.props.task.editTaskConfigurationRequest(agentTask)
            .then(this.props.onSuccess)
    }

    parseFileData = (text) => {
        console.log(text)
        const data = JSON.parse(text)
        console.log(data.agentTask)
        this.setState(EditTaskModal.getStateFromAgentTask(data.agentTask))
    }
    onFileInput = async (event) => {
        const text = await readFileAsText(event.target.files[0])
        this.parseFileData(text)
    }
    componentDidMount(){
        if (this.props.task) {
            this.props.task.loadTaskConfigurationRequest()
                .then((agentTask)=> {
                    this.setState({...EditTaskModal.getStateFromAgentTask(agentTask.agentTask)})
                })
        }
    }
    validData = () => {
        let valid = true
        const indexes = new Set()
        valid = valid
            && this.state.description.trim() !== ''
            && this.state.inputTitle.trim() !== ''
            && this.state.inputElements.length > 0

        if(this.state.inputElements.length > 0)
            this.state.inputElements.forEach(e => {
                indexes.add(e.index)
                switch(e.inputElementType){
                    case 'TEXTBOX': {
                        valid = valid
                            && e.inputElement.textbox.label.trim() !== ''
                        break
                    }
                    case 'QUESTION': {
                        valid = valid
                            && e.inputElement.question.text.trim() !== ''
                            && e.inputElement.question.questionAnswers.length > 0
                        e.inputElement.question.questionAnswers.forEach(a => valid = valid && a.answer.trim() !== '')
                        switch (e.inputElement.question.questionType) {
                            case 'DROPDOWN':
                                break
                            case 'SINGLE_CHOICE':
                                break
                            case 'MULTIPLE_CHOICE':
                                break
                            default:
                                valid = false
                                break
                        }
                        break
                    }
                    default: {
                        valid = false
                        break
                    }
                }
            })
        if (indexes.size !== this.state.inputElements.length) {
            valid = false
        }    
        return valid
    }
    render() {
        const locale = this.props.localizationStore.locale
        const confirmButton = this.props.task
            ? <TextButton text={locale.apply}
                          type={TextButtonTypes.primary}
                          onClick={this.onEditTask}
                          disabled={!this.validData()} />
            : <TextButton text={locale.create}
                          type={TextButtonTypes.primary}
                          onClick={this.onAddTask}
                          disabled={!this.validData()} />

        return (
            <DialogModal onClose={this.props.onClose}
                         button={confirmButton}>
                <div className={styles.modal}>
                    <InputField label={locale.task_description}
                                style={styles.taskName}
                                required
                                value={this.state.description}
                                name='description'
                                placeholder={locale.task_description}
                                onChange={this.onModalInputChange}
                    />
                    <InputField label={locale.task_input_title}
                                style={styles.taskName}
                                required
                                value={this.state.inputTitle}
                                name='inputTitle'
                                placeholder={locale.task_input_title}
                                onChange={this.onModalInputChange}
                    />
                    <DropDown style={styles.taskName}
                              required
                              name='interval'
                              options={locale.task_interval_options}
                              value={locale.task_interval_options[this.state.interval]}
                              onChange={this.onIntervalChange}
                              label={locale.periodicalUpdatesInterval}
                              viewedByAdministrator={this.props.store.isAdministrator()}
                    />
                    <div className={styles.modalItem}>
                        <span>{locale.drag_item}</span>
                    </div>
                    <div className={styles.form}>
                        <div className={styles.optionsContainer}>
                            <div className={styles.optionsList}>
                                {this.draggableElements.map(e => { return (
                                    <div className={styles.option} id={e.inputType+e.questionType} key={e.inputType+e.questionType}
                                         draggable='true'
                                         onDragStart={this.onDragStart}
                                         onDragEnd={this.onDragEnd}
                                    >
                                        {e.name}
                                    </div>)
                                })}
                            </div>
                        </div>
                        <div className={styles.formsContainer} onDragOver={this.onDragOver} onDrop={this.onDrop}>
                            {/*{this.state.elements.length === 0 &&*/}
                                {/*<FileInput onChange={this.onFileChanged}/>*/}
                            {/*}*/}
                            <div className={styles.formsList} id='formsList'>
                                {this.state.inputElements.map((e, i) => { return (
                                    <Form  key={i}
                                           index={e.index}
                                           state={e.inputElement}
                                           onDeleteForm={() => this.onDeleteForm(i)}
                                           onInputChange={(state, newIndex) => this.onFormInputChange(i, state, newIndex)}
                                    />
                                )})}

                                <div className={this.state.dragging ? styles.dropZoneVisible : styles.dropZoneHidden}
                                >
                                    [ {locale.drop_zone} ]
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.modalItem}>
                        <span>{locale.drop_file}</span>
                        <span>
                            <label className={styles.hiddenInputLabel} htmlFor="setConfigFile">{locale.select_file}</label>
                            <input className={styles.hiddenInput} type="file" id='setConfigFile' accept="application/json"
                                   onChange={this.onFileInput}/>
                        </span>
                    </div>
                    <div className={styles.modalItem}>
                        <span>
                            <label className={styles.hiddenInputLabel} htmlFor="getConfigFile">{locale.download_configuration}</label>
                            <input className={styles.hiddenInput} type="button" id='getConfigFile' onClick={this.handleProvideJsonFile}/>
                            <a href={this.state.downloadLink} ref={this.downloadLinkRef} target={'_blank'} style={{opacity: 0}} download={'configuration.json'}>Download link</a>
                        </span>
                    </div>
                </div>
            </DialogModal>
        );
    }
}


const intervalValues = [
    [false, null, null],
    [true, 'DAY', 1],
    [true, 'WEEK', 1],
    [true, 'WEEK', 2],
    [true, 'MONTH', 1],
    [true, 'MONTH', 3]
]

function intervalSwitch(...configValues) {
    for (let i = 0; i < intervalValues.length; i++) {
        if (intervalValues[i].every((val, index) => val === configValues[index])) {
            return i
        }
    }
    return 0
}

function getIntervalData(index) {
    const [defaultPeriodicalUpdatesEnabled, defaultPeriodicalUpdatesInterval, defaultPeriodicalUpdatesIntervalCount] = intervalValues[index]
    return {defaultPeriodicalUpdatesEnabled, defaultPeriodicalUpdatesInterval, defaultPeriodicalUpdatesIntervalCount}
}

export default AddTaskModal;


// WEBPACK FOOTER //
// ./src/components/AddTaskModal/index.js